var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.35 29.65L29.6 27.4L21.65 19.4V9.35H18.65V20.6L27.35 29.65ZM20 40C17.2667 40 14.6833 39.475 12.25 38.425C9.81667 37.375 7.69167 35.9417 5.875 34.125C4.05833 32.3083 2.625 30.1833 1.575 27.75C0.525 25.3167 0 22.7333 0 20C0 17.2667 0.525 14.6833 1.575 12.25C2.625 9.81667 4.05833 7.69167 5.875 5.875C7.69167 4.05833 9.81667 2.625 12.25 1.575C14.6833 0.525 17.2667 0 20 0C22.7333 0 25.3167 0.525 27.75 1.575C30.1833 2.625 32.3083 4.05833 34.125 5.875C35.9417 7.69167 37.375 9.81667 38.425 12.25C39.475 14.6833 40 17.2667 40 20C40 22.7333 39.475 25.3167 38.425 27.75C37.375 30.1833 35.9417 32.3083 34.125 34.125C32.3083 35.9417 30.1833 37.375 27.75 38.425C25.3167 39.475 22.7333 40 20 40ZM20 37C24.6667 37 28.6667 35.3333 32 32C35.3333 28.6667 37 24.6667 37 20C37 15.3333 35.3333 11.3333 32 8C28.6667 4.66667 24.6667 3 20 3C15.3333 3 11.3333 4.66667 8 8C4.66667 11.3333 3 15.3333 3 20C3 24.6667 4.66667 28.6667 8 32C11.3333 35.3333 15.3333 37 20 37Z",
    fill: "#1C1C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullTime);
export default __webpack_public_path__ + "static/media/full-time.09513fdbc5fa9c4df8cd898ff071f99a.svg";
export { ForwardRef as ReactComponent };